export default class Http {
  static request = async (endpoint, method = 'GET', body = null, redirect = 'manual', options = {}) => {
    const csrfMetaTag = document.querySelector('meta[name="csrf-token"]')
    const csrfToken = csrfMetaTag && csrfMetaTag.getAttribute('content')
    const fetchOptions = Object.assign({
      method: method,
      body: body,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken
      },
      credentials: 'same-origin',
      redirect: redirect
    }, options)

    return fetch(endpoint, fetchOptions)
  }
}
